/**
 * Copilot module context for empty-state prompt tabs / chips only.
 * Do NOT attach `module` or `pathname` to chat/stream or feedback payloads —
 * the AI service routes from the question alone.
 */

/** @type {string | null} */
let activeEmptyStateModuleTabId = null;

/** @param {string | null | undefined} id */
export const setCopilotEmptyStateModuleTab = (id) => {
  activeEmptyStateModuleTabId = id ? String(id) : null;
};

/** @returns {string | null} */
export const getCopilotEmptyStateModuleTab = () => activeEmptyStateModuleTabId;

/**
 * Ordered pathname rules — first match wins (more specific paths first).
 * Used only to pre-select empty-state prompt tabs.
 * @type {Array<{ test: (pathname: string) => boolean, module: string }>}
 */
const COPILOT_PATHNAME_MODULE_RULES = [
  { test: (p) => /\/rostering\/invoicing|\/invoice/i.test(p), module: "funding" },
  { test: (p) => /\/support-coordination|\/cos|\/allied|\/ah/i.test(p), module: "funding" },
  { test: (p) => /\/incident|\/complaint|\/feedback/i.test(p), module: "safety" },
  { test: (p) => /\/rostering/i.test(p), module: "rostering" },
  { test: (p) => /\/hrm/i.test(p), module: "workforce" },
  { test: (p) => /\/participant|\/sil-accommodation|\/home-management|\/sil/i.test(p), module: "participants" },
];

/**
 * @param {string} [pathname]
 * @returns {string | null}
 */
export const resolveCopilotModuleFromPathname = (pathname) => {
  const path = String(pathname || "");
  if (!path) return null;
  for (const rule of COPILOT_PATHNAME_MODULE_RULES) {
    if (rule.test(path)) return rule.module;
  }
  return null;
};
